import { NotificationPreferenceRegister, authentication } from '@ecosystem/newron-client-lib';

import { getAccessPackages } from '../lib/persona.client';
import { MarketPreferences, DistributionPreferences } from './NotificationUpdatePreferences';
import { getFeatureValue } from '../utils/featureFlag';

export const registerDataUpdatesPreferences = async (): Promise<void> => {
  const userToken = await authentication.getAccessToken();
  const userAccess = await getAccessPackages(userToken);
  const hasDistributorAccess = userAccess.includes('dist_std');
  const hasMarketAccess = userAccess.includes('mkt_std');
  const dataUpdatesFeatureEnabled = getFeatureValue('data-updates');

  if (hasMarketAccess) {
    NotificationPreferenceRegister.getInstance().register({
      group: 'data-updates',
      type: 'market-updates',
      order: 200,
      component: MarketPreferences,
    });
  }

  if (hasDistributorAccess && dataUpdatesFeatureEnabled) {
    NotificationPreferenceRegister.getInstance().register({
      group: 'data-updates',
      type: 'distribution-updates',
      order: 200,
      component: DistributionPreferences,
    });
  }
};
